import { render, staticRenderFns } from "./InfoPanel.vue?vue&type=template&id=34ed5c7d&scoped=true"
import script from "./InfoPanel.vue?vue&type=script&lang=js"
export * from "./InfoPanel.vue?vue&type=script&lang=js"
import style0 from "./InfoPanel.vue?vue&type=style&index=0&id=34ed5c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed5c7d",
  null
  
)

export default component.exports